import React, {Component} from "react"

import style from "./UnderConstructions.module.scss";
import VBox from "../boxes/VBox";
import HBox from "../boxes/HBox";
import IndexUnderConstructionSvg from "../../../../views/index/assets/IndexUnderConstructionSvg";

const UnderConstructions = (props) => {

    if(props.on === false)
        return null;

    return (
        <VBox className={style.parent}>

            <HBox className={style.content_wrapper}>

                <VBox className={style.box + " " + style.text_wrapper + " " + style.first}>
                    <h1>We are under constructions</h1>
                    <p>
                        AlsTherapy.io is coming soon. This page is currently unavailable.
                        If you have any questions or would like to
                        receive updates on our progress please feel free to email us at <a href={"mailTo:contact@alstherapy.io"}>contact@alstherapy.io</a>
                        <br/>Thank you for your support and patience.<br/>
                        <em>- AlsTherapy Team</em>
                    </p>
                </VBox>
                <VBox className={style.box + " " + style.svg_wrapper+ " " + style.last}>
                    <IndexUnderConstructionSvg/>
                </VBox>

            </HBox>
        </VBox>
    )
}

export default UnderConstructions;
